import about from "./about";
import advantage from "./advantage";
import bindPhone from "./bind-phone";
import businessCases from "./business-cases";
import component from "./component";
import learn from "./learn";
import page from "./page";
import login from "./login";
import pricing from "./pricing";
import security from "./security";
import signUp from "./sign-up";
import solution from "./solution";
import common from "./common";

export default {
  about,
  advantage,
  bindPhone,
  businessCases,
  component,
  learn,
  login,
  page,
  pricing,
  security,
  signUp,
  solution,
  common,
};
